import React from 'react';
import { SCORE_OPTIONS, SCORE_COLORS } from '../types';
import { ScorecardLayoutProps } from './types';

/**
 * Segmented layout — the five rating options shown side-by-side as a single
 * red→green grade bar. Every segment carries its scale colour so the bad↔good
 * spectrum reads at a glance; unselected grades are muted while the active
 * grade is fully saturated, larger and ringed. Fills its row, stays one tall.
 */
const ScorecardSegmentedLayout: React.FC<ScorecardLayoutProps> = ({
  currentScore,
  onSelect,
  readOnly,
}) => {
  const hasSelection = currentScore != null;
  return (
    <div className="h-full flex items-stretch bg-surface px-2 py-1.5">
      <div className="flex items-stretch gap-1 w-full">
        {SCORE_OPTIONS.map(option => {
          const isActive = currentScore === option.value;
          const colors = SCORE_COLORS[option.value];
          return (
            <button
              key={option.value}
              type="button"
              onClick={() => !readOnly && onSelect(option.value)}
              disabled={readOnly}
              aria-pressed={isActive}
              title={`Rate: ${option.label}`}
              className={[
                'flex-1 min-h-[26px] rounded-md flex items-center justify-center',
                'font-bold leading-none tracking-wide select-none transition-all',
                colors.bg,
                colors.text,
                isActive
                  ? 'text-base ring-2 ring-inset ring-white/80 shadow-sm scale-[1.02]'
                  : hasSelection
                    ? 'text-sm opacity-40 hover:opacity-80'
                    : 'text-sm opacity-70 hover:opacity-100',
                readOnly ? 'cursor-default' : 'cursor-pointer',
              ].join(' ')}
            >
              {option.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default React.memo(ScorecardSegmentedLayout);
